<template>
  <section :class="$style['finale']" aria-label="Kaarten">
    <NuxtLink to="#avond" :class="$style['finale__link']">Kaarten</NuxtLink>
    <p :class="$style['finale__where']">{{ where }}, Beursstraat 44</p>
    <ul v-if="performances.length" :class="$style['finale__dates']">
      <li v-for="performance in performances" :key="performance.id">
        <a :href="performance.url" :class="$style['finale__date']" :aria-label="performance.label">{{ performance.weekday.slice(0, 2) }} {{ performance.day }} {{ performance.month }}{{ performance.note === 'Middagvoorstelling' ? `, ${performance.time}` : '' }}</a>
      </li>
    </ul>
  </section>
</template>
<script setup lang="ts">
import type { Performance } from '~/composables/usePerformances'

// The homepage ends on amber with one giant ticket link and every date as a button
defineProps<{ performances: Array<Performance>, where: string }>()
</script>
<style module>
.finale {
  overflow: hidden;
  padding: var(--stage-section) var(--stage-gutter) var(--spacing-xxxl);
  background: var(--primary-color);
  color: var(--stage-black);
  text-align: center;
}

.finale__link {
  display: block;
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  font-size: clamp(4rem, 17vw, 19rem);
  line-height: 0.8;
  letter-spacing: -0.05em;
  text-transform: uppercase;
  color: var(--stage-black);
  text-decoration: none;
  -webkit-text-stroke: 0.04em var(--stage-black);
  transition: color 250ms;
}

.finale__link:hover {
  color: var(--primary-color);
}

.finale__where {
  margin: var(--spacing-xxl) 0 0;
  font-size: clamp(1.125rem, 1rem + 0.5vw, 1.5rem);
  line-height: 1.4;
}

.finale__dates {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-m);
  margin: var(--spacing-xxl) 0 0;
  padding: 0;
  list-style: none;
}

.finale__date {
  display: inline-flex;
  align-items: center;
  min-height: 2.75rem;
  padding: 0 var(--spacing-xl);
  border: 0.125rem solid var(--stage-black);
  border-radius: 999rem;
  color: var(--stage-black);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-small);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  text-decoration: none;
  transition: background-color 200ms, color 200ms;
}

.finale__date:hover {
  background: var(--stage-black);
  color: var(--primary-color);
}

@media (prefers-reduced-motion: reduce) {
  .finale__link,
  .finale__date {
    transition: none;
  }
}
</style>
